import React, { useEffect, useState } from "react";
import Report from "../../../models/Report";
import DataTable from "../dataTable";
import formatNumberAsPrice from "../../../utilities/formatNumberAsPrice";

export default () => {
    const [loading, setLoading] = useState(true);
    const [data, setData] = useState([]);
    useEffect(() => {
        const fetchData = async () => {
            const data = await Report.GFCSpendByMonth();
            setData(data);
            setLoading(false);
        };
        fetchData();
    }, []);

    const headers = [
        { key: "yearMonth", text: "Year / Month" },
        { key: "total", text: "Total" },
    ];

    const tableData = data.map((item) => {
        return {
            yearMonth: { value: item.yearMonth },
            total: { value: `£ ${formatNumberAsPrice(item.total)}` },
        };
    });

    return (
        <>
            <h4>GFC Spend By Month</h4>
            <p>
                View the total GFC spent for each month historically. The spend
                total is posted in the month the round was played in.
            </p>
            <DataTable
                loading={loading}
                headers={headers}
                data={tableData}
                hideSearch
                hideResultsCount
            />
        </>
    );
};
